import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { SectionHeading } from "./shared";
import { FAQS } from "../data";

export const FAQ = () => {
  return (
    <section id="faq" className="bg-[#F8F9FA] py-20 lg:py-28">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          center
          eyebrow="Întrebări Frecvente"
          title="Răspunsuri la cele mai comune întrebări"
          subtitle="Nu ai găsit răspunsul căutat? Contactează-ne și îți răspundem cu plăcere."
        />

        <div className="mt-12">
          <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
            {FAQS.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="rounded-2xl border border-gray-200 bg-white px-6 shadow-subtle data-[state=open]:border-brand/40 transition-colors"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-5 text-left text-base font-semibold text-ink hover:no-underline hover:text-brand [&[data-state=open]]:text-brand"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-ink-muted leading-relaxed text-[15px]">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
